<template>

    <section class="orders">
        <div class="container">

            <div class="box-title">
                <h1>Mis pedidos</h1>
                <p>Si tenés dudas, por favor escribinos a mayoristas@gorsh.com.</p>
            </div>

            <div class="row">
                <div class="col-lg-12">

                    <div class="panel box-pedido" v-for="order in orders" :key="order.id">

                        <h1>Pedido #{{order.nro}}</h1>
                        <h4>{{order.datetime}}</h4>

                        <div class="row">

                            <div class="col-md-4">
                                <h2>Datos de envío</h2>
                                <ul class="detalle">
                                    <li>
                                        <span>Forma de envío:</span> {{order.forma_envio}}
                                    </li>
                                    <li>
                                        <span>Nombre:</span> {{order.nombre}}
                                    </li>
                                    <li>
                                        <span>Dirección:</span> {{order.direccion}}
                                    </li>
                                </ul>
                            </div>

                            <div class="col-md-4">
                                <h2>Estado del pedido</h2>
                                <ul class="detalle">
                                    <li>
                                        <span>Estado del pago:</span> {{order.estado_pago}}
                                    </li>
                                    <li>
                                        <span>Estado del envío:</span> {{order.estado_envio}}
                                    </li>
                                    <li>
                                        <span>Forma de pago:</span> {{order.forma_pago}}
                                    </li>
                                </ul>
                            </div>

                            <div class="col-md-4">
                                <h2>Resumen de compra</h2>
                                <ul class="detalle">
                                    <li>
                                        <span>Subtotal:</span> $ {{order.subtotal}}
                                    </li>
                                    <li v-if="order.descuento>0">
                                        <span>Descuento:</span> $ {{order.descuento}}
                                    </li>
                                    <li>
                                        <span>TOTAL:</span> <span class="highlight">$ {{order.total}}</span>
                                    </li>
                                </ul>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </section>

</template>

<script>

    import Api from '@/Api'
    import { mapGetters } from 'vuex';

    export default {
        name: "MyOrdersPage",
        data(){
            return {
                orders:[]
            }
        },
        computed: {
        ...mapGetters(['user'])
        },
        mounted(){

            $('body').removeClass();

            Api().get('?func=getPedidosFromUser&hash=' + this.user.user_id).then(data=>{ // +user.user_id
                if (data.data.success){
                    this.orders = data.data.payload.orders;
                }else{
                    this.orders = [];
                }

            }).catch(err=>{

            });

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MyOrdersPage.vue